import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { UsersService } from '../services';

// Async thunk for fetching user data
export const fetchUserById = createAsyncThunk(
  'users/fetchUserById',
  async ({userId}, { rejectWithValue }) => {
    try {
      const response = await UsersService.getUserProfile(userId);
      return { id: userId, ...response.data.data };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const handleFollowUnfollow = createAsyncThunk(
  'users/handleFollowUnfollow',
  async ({ userId, currentUserId, actionType}, { getState }) => {
    return { userId, currentUserId, actionType };
  }
);

const userSlice = createSlice({
  name: 'users',
  initialState: {
    entities: {},
    loading: {},
    errors: {}
  },
  reducers: {
    // Add updateUser reducer
    updateUser: (state, action) => {
      const { id, changes } = action.payload;
      if (state.entities[id]) {
        state.entities[id] = {
          ...state.entities[id],
          ...changes
        };
      } else {
        state.entities[id] = {
          ...changes,
        };
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserById.pending, (state, action) => {
        const userId = action.meta.arg;
        state.loading[userId] = true;
        state.errors[userId] = null;
      })
      .addCase(fetchUserById.fulfilled, (state, action) => {
        const user = action.payload;
        // Preserve block fields if they exist
        const prev = state.entities[user.id] || {};
        state.entities[user.id] = {
          ...user,
          // isUserBlocked: prev.isUserBlocked,
          // isPostAddBlocked: prev.isPostAddBlocked,
          // isCommentingBlocked: prev.isCommentingBlocked
        };
        state.loading[user.id] = false;
        state.errors[user.id] = null;
      })
      .addCase(fetchUserById.rejected, (state, action) => {
        const userId = action.meta.arg;
        state.loading[userId] = false;
        state.errors[userId] = action.payload;
      })
      .addCase(handleFollowUnfollow.fulfilled, (state, action) => {
        const { userId, currentUserId, actionType } = action.payload;
        const user = state.entities[userId];
        const currentUser = state.entities[currentUserId];
        // Only update if state is not already correct
        if (user) {
          if (actionType === "follow" && !user.is_following) {
            user.is_following = true;
            user.followers_count = Math.max(0, (Number(user.followers_count) || 0) + 1);
          } else if (actionType === "unfollow" && user.is_following) {
            user.is_following = false;
            user.followers_count = Math.max(0, (Number(user.followers_count) || 0) - 1);
          }
        }
        if (currentUser) {
          if (actionType === "follow") {
            currentUser.following_count = Math.max(0, (Number(currentUser.following_count) || 0) + 1);
          } else if (actionType === "unfollow") {
            currentUser.following_count = Math.max(0, (Number(currentUser.following_count) || 0) - 1);
          }
        }
      });
  }
});

export const { 
  updateUser 
} = userSlice.actions;

export default userSlice.reducer;